import React, { useState, useEffect, useRef } from "react";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./CollapseSection.css";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";

const CollapseSection = (props) => {
  const {
    title,
    opened = true,
    tool = "",
    handleTool = null,
    toolState = false,
    setIsCollapseOpened,
    isError,
  } = props;

  const [open, setOpen] = useState(opened);

  const toggleSection = () => {
    setOpen(!open);
    if (typeof setIsCollapseOpened === "function") setIsCollapseOpened(!open);
  };
  const childHeight = useRef();

  useEffect(() => {
    if (opened) {
      setOpen(true);
    }
  }, [opened]);

  const CollapseSectionTool = () => {
    switch (tool) {
      case "switch":
        return <Switch checked={toolState} onChange={handleTool} />;
      case "button":
        return <EditIcon onClick={handleTool} />;
      default:
        return <></>;
    }
  };

  return (
    <div className="collapse-section-wrapper">
      <Grid container direction="row" className={`collapse-section-banner ${isError? 'redclass':''}`}>
        <Grid item>
          <IconButton sx={{color:'darkred.light'}} onClick={() => toggleSection()}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
        <Grid item xs>
          <Typography variant="p" sx={{color:'darkred.light',fontWeight:"bold"}} onClick={() => toggleSection()}>
            {title}
          </Typography>
        </Grid>
        <Grid item className="collapse-section-tool">
          <CollapseSectionTool />
        </Grid>
      </Grid>
      <Collapse in={open}>
        <Box ref={childHeight}>{props.children}</Box>
      </Collapse>
    </div>
  );
};

export default CollapseSection;
